import { makeAutoObservable } from 'mobx'

import RootStore from './root'

export type NotificationPermissionType = 'authorized' | 'provisional' | 'denied' | 'notDetermined' | 'unknown' | ''

export class NotificationStore {
  rootStore: RootStore
  permission: NotificationPermissionType = ''

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  setPermission(permission: NotificationPermissionType) {
    this.permission = permission
  }

  resetPermission() {
    this.permission = ''
  }
}
